<div id="session-time-out">
  <div class="row">
    <div class="col-md-4 side-body"></div>
    <div class="col-md-4 main-body" id="session-content">
      <picture>
        <source media="(min-width: 767px)" srcset="assets/images/no-large.png">
        <img id="instant-verification-icon" src="assets/images/no.png" alt="Session time out icon">
      </picture>
      <div id="session-heading">
        <h2><strong>{{cfetLabels.cfet_session_time_out.heading}}</strong></h2>
      </div>
      <div>
        <p id="session-desc1">{{cfetLabels.cfet_session_time_out.desc1}}</p>
        <p id="session-desc2">{{cfetLabels.cfet_session_time_out.desc2}}</p>
        <p id="session-desc3">{{cfetLabels.cfet_session_time_out.desc3}}</p>
      </div>
      <div class="col-md-12" id="restart-footer-column">
        <button type="button" id="btn-restart" (click)="restart($event)" (keyup)="restart($event)" class="btn-restart"
          tabindex="0">{{cfetLabels.cfet_session_time_out.restart}}</button>
      </div>
    </div>
    <div class="col-md-4 side-body"></div>
  </div>
</div>